import 'react';
import WishketSymbolText from './Icons/WishketSymbolText.js';
import WishketSymbol from './Icons/WishketSymbol.js';
import WishketText from './Icons/WishketText.js';
import YozmITSymbolText from './Icons/YozmITSymbolText.js';
import YozmITSymbol from './Icons/YozmITSymbol.js';
import YozmITText from './Icons/YozmITText.js';
import JobsSymbol from './Icons/JobsSymbol.js';

const LogoMap = new Map([
    [
        'wishket_symbol',
        WishketSymbol
    ],
    [
        'wishket_symbol_text',
        WishketSymbolText
    ],
    [
        'wishket_text',
        WishketText
    ],
    [
        'yozmIT_symbol',
        YozmITSymbol
    ],
    [
        'yozmIT_symbol_text',
        YozmITSymbolText
    ],
    [
        'yozmIT_text',
        YozmITText
    ],
    [
        'jobs_symbol',
        JobsSymbol
    ]
]);

export { LogoMap };
